<script lang="ts">
    export let width = "1.25rem";
    export let height = "1.25rem";
    export let flipped = false;
</script>

<svg viewBox="0 0 24 24" {width} {height}
    class="fillCurrentColor duration-300 transition-all"
    style={flipped ? "transform: scaleY(-1);" : ""}
    ><path d="M16.6 8.6 12 13.2 7.4 8.6 6 10l6 6 6-6-1.4-1.4z" /></svg
>
